import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MsToastMessage } from './ms-toast.model';

@Injectable({
	providedIn: 'root',
})
export class MsToastService {
	timeOut: number = 3000;
	progressBar: boolean = true;

	constructor(private _toastrService: ToastrService) {}

	success(data: MsToastMessage): void {
		this._toastrService.success(data.message, data.title, {
			timeOut: this.timeOut,
			progressBar: this.progressBar,
		});
	}

	warning(data: MsToastMessage): void {
		this._toastrService.warning(data.message, data.title, {
			timeOut: this.timeOut,
			progressBar: this.progressBar,
		});
	}

	info(data: MsToastMessage): void {
		this._toastrService.info(data.message, data.title, {
			timeOut: this.timeOut,
			progressBar: this.progressBar,
		});
	}

	error(data: MsToastMessage): void {
		this._toastrService.error(data.message, data.title, {
			timeOut: this.timeOut,
			progressBar: this.progressBar,
		});
	}
}
